import React from 'react';
import './App.css';
import {Routing} from "./components/routing/Routing";
import {useNavigate} from "react-router-dom";
import {HttpService} from "./services/http/Http.service";
import {message, Modal} from "antd";
import {ModalService} from "./services/Modal.service";
import {MessagesService} from "./services/Messages.service";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {useProgressContext} from "./services/ProgressContext";
import {StickyProgressBanner} from "./components/StickyProgressBanner";
/*
var customParseFormat = require("dayjs/plugin/customParseFormat");
*/

function App() {
  const [modal, contextHolderModal] = Modal.useModal();
  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate();

  const { progress, isPolling, hideProgressBar } = useProgressContext();

  HttpService.init(navigate);
  ModalService.init(modal)
  MessagesService.init(messageApi)
  dayjs.extend(customParseFormat);

  return <>
    <Routing></Routing>
    {isPolling && progress && !hideProgressBar && <StickyProgressBanner progress={progress} />}
  </>
}

export default App;
